import Button from 'components/Button';
import AboutModalImage from 'assets/images/about_modal.png';
import CloseIcon from 'assets/icons/close.svg';
import CustomModal from 'components/CustomModal';

interface IAboutModal {
  isOpen: boolean;
  onClose: () => void;
}

const AboutModal = ({ isOpen, onClose }: IAboutModal) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      className='max-w-[552px] rounded-2xl overflow-hidden'
    >
      <img
        className='cursor-pointer absolute top-4 right-4'
        src={CloseIcon}
        alt='Close'
        onClick={onClose}
      />
      <img
        src={AboutModalImage}
        alt='Compass'
        className='w-full object-contain'
      />
      <div className='p-8'>
        <p className='font-semibold text-[28px] mb-4'>Welcome to Compass!</p>
        <p className='font-light text-base/[22px] text-gray-700 h-[200px] overflow-y-auto'>
          The most critical data and insights, highlighting the core performance
          metrics and trends across Compass software benchmarks¹, with 38,000+ data
          points spanning over 12 years of quarterly data.
          <br />
          <br />
          ICONIQ seeks to maintain the security, confidentiality, and anonymity
          of our users' data. The below outlines how we intend to collect and
          handle data, seeking to ensure a safe and secure experience while
          using Compass.
          <br />
          <br />
          <span className='font-bold text-[18px]'>Data Collection</span>
          <br />
          <br />
          We collect data from users of Compass to provide our services
          effectively. By entering your data, you consent to the retention and
          use by ICONIQ of your answers for future use. Your data will be
          handled securely and if any data is included in materials that are
          publicly available, such data is expected to be aggregated or/and
          anonymized. All collected data is stored in our secure databases in a
          table isolated from our other systems and unauthorized staff.
          <br />
          <br />
          Users can also opt out of providing any identifying information like
          company name / website.
          <br />
          <br />
          <span className='font-bold text-[18px]'>
            Data Analysis and Confidentiality
          </span>
          <br />
          <br />
          All analysis performed on user data and presented to our users is
          expected to be based on aggregated statistical results. We generally
          follow the principle of "minimum aggregation," aiming to ensure that
          no statistic is revealed unless it satisfies the minimum n-size of 8
          datapoints. For example, we would typically only show a median value
          for a metric like net dollar retention with 8 or more datapoints. This
          approach prevents the identification of individual users or companies
          through their data.
        </p>
        <Button
          label='Explore'
          id='explore'
          onClick={onClose}
          className='mt-8 w-full p-[9px] rounded-5xl bg-transparent text-lg font-light text-center text-white bg-black dark:bg-white dark:text-black hover:bg-[#404040] dark:hover:bg-gray-400 transition-all duration-300'
        />
      </div>
    </CustomModal>
  );
};

export default AboutModal;
